import { useTranslation } from 'react-i18next';

export type Params = {
    seconds: number;
    onChangeSeconds: (seconds: number) => void;
};

export const CheckInLine = ({ seconds, onChangeSeconds }: Params) => {
    const { t } = useTranslation();
    return (
        <div className="checkin-line">
            <span>{ t('DEVICE.COMMANDS.NEXT_CHECK_IN') }</span>
            <input
                type="text"
                value={ `${seconds}` }
                className="ui input"
                style={ {
                    marginLeft: '1em',
                    width: '4em',
                    textAlign: 'right',
                } }
                onChange={ (e: any) => onChangeSeconds(parseInt(e.target.value, 10)) }
                maxLength={ 5 }
            />
            <span>{ t('DEVICE.COMMANDS.SECONDS') }</span>
        </div>
    );
};
